export default __webpack_public_path__ + "static/media/impacto_social.7110d9dd.jpg";